import { AnimalGroupData } from "./animalGroups";
import { ConditionData } from "./conditions";

export type FilterParameter = {
  [key: string]: number
}

export const DataLevels = ["Animal", "Group", "Location"] as const;
export type DataLevel = typeof DataLevels[number]; 

export const DataParameters = ["Location", "Group", "Condition", "Attention", "Milestone"] as const;
export type DataParameter = typeof DataParameters[number]; 

export type ReportTemplate = {
    reportTemplateNo: number // DataTYPE ID, static
    name: string // Editable for farmer
    dataLevel: DataLevel
    filterParameter: FilterParameter[]
    dataParameter: DataParameter[]
  };

export const TestData: ReportTemplate[] = [
  {
    reportTemplateNo: 1,
    name: "Standard Condition Score",
    dataLevel: "Animal",
    filterParameter: [
      {groupId: 1}
    ],
    dataParameter: [
      "Condition",
      "Group"
    ]
  },
  {
    reportTemplateNo: 2,
    name: "Feed Plan and Condition Score",
    dataLevel: "Group",
    filterParameter: [
      {groupId: 3},
      {conditionId: 1}
    ],
    dataParameter: [
      "Location",
      "Group"
    ]
  },
  {
    reportTemplateNo: 3,
    name: "Feed Plan",
    dataLevel: "Animal",
    filterParameter: [
      {groupId: 1},
      {conditionId: 2}
    ],
    dataParameter: [
      "Group"
    ]
  },
  {
    reportTemplateNo: 4,
    name: "Condition Score",
    dataLevel: "Location",
    filterParameter: [
      {groupId: 2},
      {conditionId: 3}
    ],
    dataParameter: [
      "Location",
    ]
  },
  {
    reportTemplateNo: 5,
    name: "Feed Balance",
    dataLevel: "Location",
    filterParameter: [
      {groupId: 2}
    ],
    dataParameter: [
      "Location",
    ]
  },
  {
    reportTemplateNo: 6,
    name: "Feed Balance (Farrowing)",
    dataLevel: "Location",
    filterParameter: [
      {groupId: 2}
    ],
    dataParameter: [
      "Attention",
    ]
  },
  {
    reportTemplateNo: 7,
    name: "Farrowing",
    dataLevel: "Location",
    filterParameter: [
      {groupId: 2}
    ],
    dataParameter: [
      "Milestone",
    ]
  }
]